// GET

import axios, { AxiosResponse } from 'axios';
import { UpdateRecommendedProductsInput } from 'views/site-settings/features/inventory-silo-management/types/update-recommended-products-input.type';
import { RecommendedProduct } from '../types/recommended-product.type';
import { SiteSettingsProduct } from '../types/site-settings-product.type';

// /ewosapi/v1/site-settings/{globalSiteId}/assortmentproducts
export const getSiteSettingsProductAssortment = async (globalSiteId: string): Promise<SiteSettingsProduct[]> => {
  const res = await axios.get<SiteSettingsProduct[]>(`/ewosapi/v1/site-settings/${globalSiteId}/assortmentproducts`);
  return res.data;
};

// PUT
// /ewosapi/v1/site-settings/{globalSiteId}/recommendedproduct
//Set Recommended Products per Site
export const putRecommendedProducts = async (
  globalSiteId: string,
  request: UpdateRecommendedProductsInput
): Promise<AxiosResponse> => {
  return await axios.put(`/ewosapi/v1/site-settings/${globalSiteId}/recommendedproduct`, request);
};
